<template>
  <table style="width: 100%;">
    <tr>
      <td v-for="(item, ind) in copies" v-bind:style="getStyle(ind)">

        <table style="width: 100%">
          <tr>
            <td style="width: 20%; text-align: left; padding-top: 2%">
              <img style="width: 100%" v-bind:src="head.Logo" />
            </td>
            <td style="text-align: center; padding-top: 2%; vertical-align: top">
              <h4 style="margin-bottom: 0px">{{head.Name}}</h4>
            </td>
            <td style="width: 20%; text-align: right; padding-top: 2%">
              <img style="width: 100%" v-bind:src="head.QR" />
            </td>
          </tr>
        </table>

        <table style="width: 100%;" border="1">
          <thead>
            <tr>
              <th colspan="4" style="text-align: center">{{item}}</th>
            </tr>
          </thead>
        </table>

        <table style="width: 100%; font-size: 10px;" border="1">
          <tbody>
            <tr>
              <th style="width: 20%">Challan No</th>
              <td style="font-size: 12px; width: 30%; font-weight: bold">{{st.ChallanNo}}</td>
              <th style="width: 20%">Session</th>
              <td style="font-size: 12px; width: 30%; font-weight: bold">{{st.Session}}</td>
            </tr>
            <tr>
              <th>Due Date</th>
              <td style="width: 30%; font-size: 12px; font-weight: bold">{{st.DueDate}}</td>
              <th>Issue Date</th>
              <td style="width: 30%; font-size: 12px; font-weight: bold">{{st.DateGeneration}}</td>
            </tr>
            <tr>
              <th style="width: 20%">Program</th>
              <td colspan="3" style="">{{st.Program}}</td>
            </tr>
            <tr>
              <th>Name</th>
              <td>{{st.StudentName}}</td>
              <th>Father Name</th>
              <td>{{st.FathersName}}</td>
            </tr>
          </tbody>
        </table>

        <table style="width: 100%; font-size: 10px;" border="1">
          <thead>
            <tr>
              <th style="width: 80%">Fee Particulars</th>
              <th style="width: 20%; text-align: right">Amount</th>
            </tr>
          </thead>
          <tbody>

            <tr v-for="item in fee">
              <td style="width: 80%">
                <span v-if="item.FeeSetupID == 0">{{item.Name}}</span>
                <b v-else>{{item.Name}}</b>
              </td>
              <td style="width: 20%; text-align: right">
                <span v-if="item.FeeSetupID == 0">{{item.Amount.toLocaleString()}}</span>
                <b v-else>{{item.Amount.toLocaleString()}}</b>
              </td>
            </tr>

            <tr>
              <th style="width: 80%; font-weight:bold">Grand Total</th>
              <th style="width: 20%; text-align:right; font-weight:bold">{{st.GrandTotal.toLocaleString()}}</th>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="2" style="text-align: center">{{words}}</th>
            </tr>
          </tfoot>
        </table>

        <table style="width: 100%; font-size: 10px;" border="1">
          <thead>
            <tr>
              <th>Note:</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="padding-right: 17px;">
                <ol style="padding-left: 17px;"> 
                  <li>This is a Fee Refund Challan.</li> 
                  <li>This challan is issued without cutting and overwritting.</li> 
                </ol>
              </td>
            </tr>
          </tbody>
        </table>

        <table style="width: 100%; margin-top: 65px; border-top: 1px solid black">
          <tr>
            <td style="text-align: center; font-weight: bold">Signature & Stamp</td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</template>

<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        img: '',
        st: [],
        sum: 0,
        otherfee: 0,
        proceptfee: 0,
        fee: [],
        words: '',
        head: [],
        print: '',
        dueDate: '',
        copies: ['Account Office Copy', 'Treasurer Copy', 'Department Copy', 'Applicant Copy']
      }
    },

    created: function () {
      this.loadChallanDetail();
    },

    methods: {
      loadChallanDetail() {
        var vm = this;
        axios.post('/api/FeeApi/loadGenerateFeeData')
          .then(function (response) {
            vm.st = response.data.st;
            //vm.dueDate = response.data.dueDate;
            vm.head = response.data.head;
            vm.fee = response.data.fee;
            vm.words = response.data.words;
            vm.sum = 0
            vm.otherfee = 0
            vm.proceptfee = 0
            for (var i = 0; i < vm.dataa.length; i++) {

              vm.sum += vm.dataa[i].Amount
              if (vm.dataa[i].Priority === 1) {
                vm.proceptfee += vm.dataa[i].Amount
              } else {

                vm.otherfee += vm.dataa[i].Amount
              }
            }
            vm.sum += vm.dataa[0].EntryTestFee
          })
          .catch(function (error) {
            console.log(error);
          })
      },

      getStyle(ind) {
        if (ind == 0)
          return "width: 25%; border-right: 2px dotted black; padding-right: 15px; padding-left: 15px;";
        else if (ind == 1)
          return "width: 25%; border-right: 2px dotted black; padding-left: 15px; padding-right: 15px;"
        else if (ind == 2)
          return "width: 25%; padding-left: 15px; padding-right: 15px;"
        else
          return "width: 25%; border-left: 2px dotted black; padding-left: 15px; padding-right: 15px"
      },
    }

  })
</script>

<style scoped>
  table {
    border-collapse: collapse;
    font-size: 14px;
    margin-top: 12px;
  }

  tr {
    border-collapse: collapse;
  }

  td {
    border-collapse: collapse;
    padding-left: 2px;
  }

  th {
    text-align: left;
    padding-left: 1px;
    background-color: lightgrey;
  }

  @page {
    size: landscape
  }

  @media print {
    #printbtn {
      display: none;
    }
  }

  .btn {
    background-color: #438eb9;
    color: white;
    padding-top: 4px;
    padding-bottom: 4px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/fee/adjustmentChallanPrint.vue